import { render, staticRenderFns } from "./companyVoteModal.vue?vue&type=template&id=1edf1f1b&scoped=true&"
import script from "./companyVoteModal.vue?vue&type=script&lang=js&"
export * from "./companyVoteModal.vue?vue&type=script&lang=js&"
import style0 from "./companyVoteModal.vue?vue&type=style&index=0&id=1edf1f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf1f1b",
  null
  
)

export default component.exports